import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { ProductSubscription, ProductSubscriptionSuccessFeeTier } from '../../shared/models';
import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';

interface SuccessFeeTierActionProps {
	tier: ProductSubscriptionSuccessFeeTier;
	onEdit: (tier: ProductSubscriptionSuccessFeeTier) => void;
	onDelete: (tier: ProductSubscriptionSuccessFeeTier) => void;
}

type PageActionItem = keyof typeof PageActionItemMap;
const PageActionItemMap = {
	Edit: 'Edit',
	Delete: 'Delete',
};

export const SuccessFeeTierActionButton: React.FC<SuccessFeeTierActionProps> = ({ tier, onEdit, onDelete }) => {
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const handleClick = (action: PageActionItem) => {
		switch (action) {
			case 'Edit':
				onEdit(tier);
				break;
			case 'Delete':
				onDelete(tier);
				break;
		}
	};

	const handleClose = (event: Event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}

		setOpen(false);
	};

	const handleMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, actionItem: PageActionItem) => {
		setOpen(false);
		handleClick(actionItem);
	};

	return (
		<>
			<ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
				<Button onClick={handleToggle}>Actions</Button>
				<Button
					size="small"
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label="select merge strategy"
					aria-haspopup="menu"
					onClick={handleToggle}
				>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Popper
				open={open}
				style={{ zIndex: 1000, margin: 0 }}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList id="split-button-menu" autoFocusItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'Edit')}>
										{PageActionItemMap['Edit']}
									</MenuItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'Delete')}>
										{PageActionItemMap['Delete']}
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};
